import { Modal, Button } from "react-bootstrap"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

// eslint-disable-next-line react/prop-types
function ValidationAlert({show, setShow, questionNumber}) {
    const [questionNumberString, setQuestionNumberString] = useState("")
    useEffect(() => {
        // eslint-disable-next-line react/prop-types
            if (questionNumber.length) {
                const madeUpString = questionNumber.reduce((acc, curr, index) => {
                    if (index === 0) {
                        return curr
                    } else if (index === questionNumber.length - 1) {
                        return `${acc} and ${curr}`
                    } else {
                        return `${acc}, ${curr}`
                    }
                }, "")
                setQuestionNumberString(madeUpString)
            }
    }, [questionNumber])
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h4 className="text-danger">Warning</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>{`The percentage values for ${ questionNumber.length == 1 ? "question" : "questions" }  ${questionNumberString} must sum to exactly 100%`}</Modal.Body>
            <Modal.Footer>
                <Button
                    size="sm"
                    variant="primary"
                    onClick={() => setShow(false)}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

ValidationAlert.prototype = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    questionNumber: PropTypes.arrayOf(PropTypes.any).isRequired,
}

export default ValidationAlert;